export default __webpack_public_path__ + "static/media/ID_NEWYORK_CALLAGHAN.dcfc614a.jpg";